import { render, staticRenderFns } from "./Korting5.vue?vue&type=template&id=0e07e4ca"
import script from "./Korting5.vue?vue&type=script&lang=js"
export * from "./Korting5.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports